import React from 'react';
import { Link } from 'gatsby';
import './Navigation.scss';

const menuItems = [
  {
    title: '2M2 Strona Główna',
    path: '/'
  },
  {
    title: 'Portfolio',
    path: '/portfolio'
  },
  {
    title: 'O 2M2',
    path: '/m2m'
  },
  {
    title: 'Kontakt',
    path: '/kontakt'
  }
];

export default () => (
  <>
    {/*  mobile nav button */}
    <div className="nav-button-holder">
      <div className="nav-button vis-m">
        <span />
        <span />
        <span />
      </div>
    </div>
    {/*  mobile nav button end */}
    {/*  navigation  */}
    <div className="nav-holder">
      <nav>
        <ul>
          {menuItems.map(({ path, title }) => (
            <li key={path}>
              <Link to={path} activeClassName="act-link">
                {title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
    {/*  navigation  end */}
  </>
);
